import { render, staticRenderFns } from "./WarehouseDocumentsPage.vue?vue&type=template&id=5efe1516"
import script from "./WarehouseDocumentsPage.vue?vue&type=script&lang=js"
export * from "./WarehouseDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDocumentsPage.vue?vue&type=style&index=0&id=5efe1516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports